/**
 * Decode URL-encoded location strings
 */
function decodeLocationString(encoded: string): string {
  return decodeURIComponent(encoded);
}

/**
 * Get location data from Vercel headers with proper URL decoding
 */
export function getLocationFromHeaders(headers: {
  get: (key: string) => string | null;
}) {
  const country = headers.get('X-User-Country');
  const region = headers.get('X-User-Region');
  const city = headers.get('X-User-City');
  const timezone = headers.get('X-User-Timezone');
  const postalCode = headers.get('X-User-Postal-Code');

  if (city && country) {
    return {
      city: decodeLocationString(city),
      country: decodeLocationString(country),
      region: region ? decodeLocationString(region) : undefined,
      timezone: timezone ? decodeLocationString(timezone) : undefined,
      postalCode: postalCode ? decodeLocationString(postalCode) : undefined
    };
  }

  return undefined;
}

/**
 * Update user location from Vercel headers
 */
export function updateUserLocationFromHeaders(headers: {
  get: (key: string) => string | null;
}): void {
  const { userAppData } = require('./UserAppData');
  const locationData = getLocationFromHeaders(headers);
  if (locationData) {
    userAppData.setUserLocation(locationData);
  }
}

/**
 * Get formatted location string from headers with URL decoding
 */
export function getFormattedLocationFromHeaders(headers: {
  get: (key: string) => string | null;
}): string | undefined {
  const location = headers.get('X-User-Location');
  return location ? decodeLocationString(location) : undefined;
}

/**
 * Format location data for display
 */
export function formatLocationForDisplay(location: { city: string; country: string; region?: string }): string {
  let formatted = `${location.city}, ${location.country}`;
  if (location.region && location.region !== location.city) {
    formatted += ` (${location.region})`;
  }
  return formatted;
}
